export default __webpack_public_path__ + "static/media/aboutWave.f87b30b4.png";